import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  
  private timeout: number | null = null

  search() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = window.setTimeout(() => {
      const form = this.element as HTMLFormElement
      form.requestSubmit()
    }, 500)
  }

  submit() {
    const form = this.element as HTMLFormElement
    form.requestSubmit()
  }
}
